import React, { useState } from "react";
import { Upload, Button } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import Loader from "./Loader/Loader";
import { toast } from "react-toastify";
import { allStrings } from "./TenantUtils";
import Services from "../../../Services/dataService";

const UploadComponent = ({ getData }) => {
	const [dataUploaded, setDataUploaded] = useState(false);

	const customRequest = async ({ file, onSuccess, onError }) => {
		const formData = new FormData();
		formData.append("file", file);
		setDataUploaded(true);
		try {
			const response = await Services.uploadExcelFile({
				file: formData
			});
			onSuccess(response.data);
			const stringJson = allStrings(response.data);
			getData(stringJson);
			//   message.success("File uploaded successfully");
			toast.success("File uploaded successfully");
			setDataUploaded(false);
		} catch (error) {
			onError(error);
			toast.error(error.response.data.message);
			setDataUploaded(false);
		}
	};

	return (
		<Upload customRequest={customRequest}>
			<Button style={{ width: "100%", height: 50 }} icon={<UploadOutlined />}>
				{!dataUploaded ? "Click to Upload" : <Loader />}
			</Button>
		</Upload>
	);
};

export default UploadComponent;
